import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Popover from 'components/common/Popover'
import Media from 'components/common/Media'
import { TOOLTIPS } from 'components/common/Popover/constants'
import { GrayCheckbox } from '../../../../Common.styles'
import {
  Cell,
  PriceCell,
  ItemText,
  SubTitle,
  Title,
  PopoverContainer,
  PopoverInnerContent
} from './CommonStyles'

const TPMSItem = ({
  price = 0,
  brand: name,
  quantity = 0,
  handlePopoverClick,
  genericId,
  displayCheckbox,
  ...props
}) =>
  <Table>
    <Cell width="90">
      { displayCheckbox && <StyledCheckbox { ...props } id={ genericId } margin="0" label="" /> }
      <Content displayCheckbox={ displayCheckbox }>
        <Title>
          <Text displayCheckbox={ displayCheckbox } htmlFor={ genericId }>Tire Pressure Monitoring System Kit</Text>
          <PopoverContainer onClick={ handlePopoverClick }>
            <Popover
              centered
              components={{ PopoverInnerContent }}
              info={ TOOLTIPS[name] }
              small
              data-at-tpms-tooltip />
          </PopoverContainer>
        </Title>
        <SubTitle>Suggested by your vehicle’s manufacturer based on year, make and model.</SubTitle>
      </Content>
    </Cell>
    <Media.Desktop>
      <UnitPrice textAlign="center">
        ${(price / quantity).toFixed(2)}
      </UnitPrice>
    </Media.Desktop>
    <PriceCell width="15">
      ${price.toFixed(2)}
    </PriceCell>
  </Table>

TPMSItem.propTypes = {
  brand: PropTypes.string,
  displayCheckbox: PropTypes.bool,
  genericId: PropTypes.string,
  handlePopoverClick: PropTypes.func,
  price: PropTypes.number,
  quantity: PropTypes.number
}

export default TPMSItem


const Table = styled.div`
  position: relative;
  padding: 10px 0;
  margin-bottom: 10px;
  overflow-x: hidden;
  display: table;
  table-layout: fixed;
  width: 100%;
`

const Text = styled(ItemText)`
  ${props => props.displayCheckbox && css`
    cursor: pointer;
  `}
`

const StyledCheckbox = styled(GrayCheckbox)`
  margin-top: 3px;
  position: absolute;
`

const UnitPrice = styled(PriceCell)`
  width: 165px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.displayCheckbox && css`
    margin-left: 25px;
  `}
`
